import React from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { useDispatch } from 'react-redux';
import DebitNoteForm from '../components/DebitNoteForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { generalPublicDetails } from '../../../utils/generalPublicDetails';
import { useCreateDebitNoteHandler } from '../dataHandlers/createDebitNoteHandler';

export default function CreateDebitNotePage() {
  useDocumentTitle('Debit Notes Form');
  const navigate = useNavigate();
  const location = useLocation();
  const document = location.state.document;

  const onDebitNoteCreated = ({ payload }) => {
    if (payload.status === 'draft') {
      navigate('/drafts?tab=debit-notes');
    } else {
      navigate('/documents?tab=debit-notes');
    }
  };

  const { onSubmit, error } = useCreateDebitNoteHandler({ onSuccess: onDebitNoteCreated });

  const onSaveAsEInv = async (data) => {
    const payload = {
      ...data,
      status: 'active',
    };

    await onSubmit(payload, data.status);
  };

  const onSaveAsDraft = async (data) => {
    const payload = {
      ...data,
      status: 'draft',
      billed_to: data.billed_to ? data.billed_to : generalPublicDetails,
    };
    await onSubmit(payload, data.status);
  };

  const onCancel = async () => {
    navigate(location.state?.from || '/documents?tab=debit-notes');
  };

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <DebitNoteForm
        initialData={document || {}}
        onSubmit={onSaveAsEInv}
        onSaveDraft={onSaveAsDraft}
        onCancel={onCancel}
        apiErrors={error}
        isDraftButtonEnabled={location.state?.isDraftButtonEnabled}
      />
    </Stack>
  );
}
